module.exports = __webpack_public_path__ + "media/applicants/workwhenever-c3b23024.svg";